import { render, staticRenderFns } from "./RegistersTable.vue?vue&type=template&id=78d0579f&scoped=true&"
import script from "./RegistersTable.vue?vue&type=script&lang=js&"
export * from "./RegistersTable.vue?vue&type=script&lang=js&"
import style0 from "./RegistersTable.vue?vue&type=style&index=0&id=78d0579f&prod&lang=css&"
import style1 from "./RegistersTable.vue?vue&type=style&index=1&id=78d0579f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d0579f",
  null
  
)

export default component.exports